import React from "react";
import { CircularProgress, Switch } from "@mui/material";

function CustomToggleSwitch(props) {
   const { checked, onChange, isLoading } = props;
   return (
      <div style={{ width: "5rem" }} className="d-flex justify-content-center">
         {isLoading ? (
            <CircularProgress size={20} color="inherit" />
         ) : (
            <Switch
               checked={checked}
               onChange={onChange}
               inputProps={{ "aria-label": "controlled" }}
            />
         )}
      </div>
   );
}

export default CustomToggleSwitch;
